<ng-container [formGroup]="metadataFormGroup">
  <div class="row mb-2">
    <div class="col">
      <label i18n>Il s'agit de</label>
      <select class="form-control" formControlName="requestType">
        <option
          *ngFor="let requestType of vehicleRequestTypeValues"
          [ngValue]="requestType"
        >
          {{ getVehicleRequestTypeLabel(requestType) }}
        </option>
      </select>
    </div>
  </div>
  <ng-container formGroupName="vehicle">
    <div class="row my-2">
      <div class="col">
        <label i18n>N° d'homologation</label>
        <input
          class="form-control"
          formControlName="certificateId"
          type="text"
        />
      </div>
    </div>
    <div
      class="row my-2"
      *ngIf="
        metadataFormGroup.controls['requestType'].value !== 'NEW_IMATRICULATION'
      "
    >
      <div class="col">
        <label i18n>N° d'immatriculation</label>
        <input
          class="form-control"
          formControlName="immatriculation"
          type="text"
        />
      </div>
    </div>
    <div class="row my-2">
      <div class="col">
        <label i18n>Date de la 1ère mise en circulation</label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="firstImmatriculationDate"
          name="firstImmatriculationDate"
          [ngModelOptions]="{ standalone: true }"
        />
      </div>
    </div>
    <div class="row row-cols-md-2 row-cols-1">
      <div class="col">
        <label for="brand" class="mb-1" i18n>Marque</label>
        <div class="input-container">
          <input
            id="brand"
            type="text"
            class="form-control text-capitalize"
            [matAutocomplete]="autoBrands"
            id="brand-form"
            [formControl]="brandControl"
          />
          <mat-spinner *ngIf="isBrandsLoading" matSuffix diameter="16" />
        </div>
        <mat-autocomplete #autoBrands="matAutocomplete">
          <mat-option
            *ngFor="let brand of filteredBrands | async"
            [value]="formatBrandName(brand.name)"
            (onSelectionChange)="onBrandChange(brand)"
            class="text-capitalize"
          >
            {{ formatBrandName(brand.name) }}
          </mat-option>
        </mat-autocomplete>
      </div>
      <div class="col">
        <div class="input-container">
          <label i18n>Modèle</label>
          <input
            id="model"
            matInput
            type="text"
            class="form-control"
            [matAutocomplete]="autoModels"
            id="brand-form"
            [formControl]="modelControl"
          />
          <mat-spinner *ngIf="isModelsLoading" matSuffix diameter="16" />
        </div>
        <mat-autocomplete #autoModels="matAutocomplete">
          <mat-option
            *ngFor="let vehicle of filteredModels | async"
            [value]="vehicle.model.name"
            (onSelectionChange)="onModelChange(vehicle)"
          >
            {{ vehicle.model.name }}
            <div class="mb-3">
              <small class="text-muted">{{ vehicle.model.modelName }}</small
              ><br />
              <small class="text-muted">{{
                vehicle.model.transmission +
                  ' - ' +
                  vehicle.model.power +
                  'CV - ' +
                  vehicle.model.fuel +
                  ' - ' +
                  vehicle.model.body +
                  ' - ' +
                  vehicle.model.doors +
                  ' portes'
              }}</small>
            </div>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
  </ng-container>
  <div class="row row-cols-md-2 row-cols-sm-1 my-2">
    <div class="col">
      <label i18n>Distance parcourue</label>
      <select class="form-control" formControlName="distance">
        <option
          *ngFor="let distance of distanceEnumValues"
          [ngValue]="distance"
        >
          {{ getDistanceEnumLabel(distance) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Utilisation(s) principal(e) du véhicule</label>
      <select class="form-control" formControlName="mainUse">
        <option *ngFor="let use of vehicleUseValues" [ngValue]="use">
          {{ getVehicleUseLabel(use) }}
        </option>
      </select>
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-2">
    <div class="col">
      <label i18n>Lieu de stationnement la nuit</label>
      <input class="form-control" formControlName="parkingArea" type="text" />
    </div>
    <div class="col">
      <label i18n>A-t-il un garage pour le stationnement</label>
      <select class="form-control" formControlName="garage">
        <option *ngFor="let garage of garageEnumValues" [ngValue]="garage">
          {{ getVehicleGarageLabel(garage) }}
        </option>
      </select>
    </div>
  </div>
  <div class="my-4" formGroupName="policyHolder">
    <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
      Informations sur le preneur d'assurance
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Genre</label>
        <select class="form-control" formControlName="sex">
          <option *ngFor="let gender of genders" [ngValue]="gender">
            {{ getSexLabel(gender) }}
          </option>
        </select>
      </div>
      <div class="col">
        <label i18n>NPA</label>
        <input
          class="form-control"
          type="number"
          min="0"
          formControlName="npa"
        />
      </div>
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Nationalité</label>
        <select
          class="form-control"
          name="nationality"
          formControlName="nationality"
        >
          <option
            *ngFor="let countryISO of countriesISO"
            [ngValue]="countryISO"
          >
            {{ countries[countryISO][languageCode] }}
          </option>
        </select>
      </div>
      <div class="col">
        <label i18n> Date de naissance </label>
        <input
          class="form-control"
          type="date"
          [(ngModel)]="policyHolderBirthDate"
          name="policyHolderBirthDate"
          [ngModelOptions]="{ standalone: true }"
        />
      </div>
    </div>
    <div class="my-3">
      <label i18n
        >Le conducteur principal est différent du preneur d'assurance ?</label
      >
      <div class="form-check">
        <input
          type="radio"
          name="differentPerson"
          id="differentPersonTrue"
          [value]="true"
          [(ngModel)]="differentPerson"
          [ngModelOptions]="{ standalone: true }"
        />
        <label class="form-check-label" for="differentPersonTrue" i18n>
          Oui
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="differentPerson"
          id="differentPersonFalse"
          [value]="false"
          [(ngModel)]="differentPerson"
          [ngModelOptions]="{ standalone: true }"
        />
        <label class="form-check-label" for="differentPersonFalse" i18n>
          Non
        </label>
      </div>
    </div>
    <ng-container *ngIf="differentPerson">
      <div class="my-4" formGroupName="mainDriver">
        <div class="row row-cols-md-2 row-cols-sm-1 my-3">
          <div class="col">
            <label i18n>Genre</label>
            <select class="form-control" formControlName="sex">
              <option *ngFor="let gender of genders" [ngValue]="gender">
                {{ getSexLabel(gender) }}
              </option>
            </select>
          </div>
          <div class="col">
            <label i18n>NPA</label>
            <input
              class="form-control"
              type="number"
              min="0"
              formControlName="npa"
            />
          </div>
        </div>
        <div class="row row-cols-md-2 row-cols-sm-1 my-3">
          <div class="col">
            <label i18n>Nationalité</label>
            <select
              class="form-control"
              name="nationality"
              formControlName="nationality"
            >
              <option
                *ngFor="let countryISO of countriesISO"
                [ngValue]="countryISO"
              >
                {{ countries[countryISO][languageCode] }}
              </option>
            </select>
          </div>
          <div class="col">
            <label i18n> Date de naissance </label>
            <input
              class="form-control"
              type="date"
              [(ngModel)]="driverBirthDate"
              name="driverBirthDate"
              [ngModelOptions]="{ standalone: true }"
            />
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="my-3 row row-cols-md-2 row-cols-sm-1">
    <div class="col">
      <label i18n>Le véhicule est en leasing ?</label>
      <div class="form-check">
        <input
          type="radio"
          name="leasing"
          id="leasingTrue"
          [value]="true"
          formControlName="leasing"
        />
        <label class="form-check-label" for="leasingTrue" i18n> Oui </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="leasing"
          id="leasingFalse"
          [value]="false"
          formControlName="leasing"
        />
        <label class="form-check-label" for="leasingFalse" i18n> Non </label>
      </div>
    </div>
    <div class="col" *ngIf="metadataFormGroup.controls['leasing'].value">
      <label i18n>Nom de la compagnie de leasing</label>
      <input
        type="text"
        class="form-control"
        formControlName="leasingCompany"
      />
    </div>
  </div>
  <div class="my-4" formGroupName="covers">
    <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
      Couvertures
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Franchise casco partielle</label>
        <input
          class="form-control"
          type="number"
          min="0"
          formControlName="partialCoverDeductible"
        />
      </div>
      <div class="col">
        <label i18n>Franchise casco complète</label>
        <input
          class="form-control"
          type="number"
          min="0"
          formControlName="collisionDeductible"
        />
      </div>
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Couvertures supplémentaires</label>
        <mat-form-field class="lty-input">
          <mat-select
            [formControl]="
              getControl(
                getGroup(metadataFormGroup.controls['covers']).controls[
                  'prestations'
                ]
              )
            "
            multiple
          >
            <mat-option
              *ngFor="let prestation of vehiclePrestationValues"
              [value]="prestation"
              >{{ getVehiclePrestationLabel(prestation) }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col" *ngIf="personalBelongingsInCovers">
        <label i18n>Valeur des effets personnels</label>
        <input
          class="form-control"
          type="number"
          min="0"
          formControlName="personalBelongingsValue"
        />
      </div>
    </div>
  </div>
  <div class="mt-4">
    <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
      Questionnaire
    </div>
    <div class="row">
      <div class="col">
        <label i18n
          >Est-il actuellement assuré en tant que propriétaire d'un véhicule à
          moteur ?</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="isInsured"
            id="isInsuredTrue"
            [value]="true"
            formControlName="isInsured"
          />
          <label class="form-check-label" for="isInsuredTrue" i18n> Oui </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="isInsured"
            id="isInsuredFalse"
            [value]="false"
            formControlName="isInsured"
          />
          <label class="form-check-label" for="isInsuredFalse" i18n>
            Non
          </label>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="metadataFormGroup.controls['isInsured'].value">
      <div class="col">
        <label i18n
          >Cette offre remplacera-t-elle un contrat existant auprès d'une autre
          compagnie ?</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="replaceContract"
            id="replaceContractTrue"
            [value]="true"
            formControlName="replaceContract"
          />
          <label class="form-check-label" for="replaceContractTrue" i18n>
            Oui
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="replaceContract"
            id="replaceContractFalse"
            [value]="false"
            formControlName="replaceContract"
          />
          <label class="form-check-label" for="replaceContractFalse" i18n>
            Non
          </label>
        </div>
      </div>
    </div>
    <div
      class="row"
      *ngIf="metadataFormGroup.controls['replaceContract'].value"
    >
      <div class="col">
        <label i18n>Nom de la compagnie</label>
        <input class="form-control" type="text" formControlName="oldCompany" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label i18n>Son permis de conduire lui a été retiré ?</label>
        <div class="form-check">
          <input
            type="radio"
            name="hasAlreadyLostLicense"
            id="hasAlreadyLostLicenseTrue"
            [value]="true"
            formControlName="hasAlreadyLostLicense"
          />
          <label class="form-check-label" for="hasAlreadyLostLicenseTrue" i18n>
            Oui
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="hasAlreadyLostLicense"
            id="hasAlreadyLostLicenseFalse"
            [value]="false"
            formControlName="hasAlreadyLostLicense"
          />
          <label class="form-check-label" for="hasAlreadyLostLicenseFalse" i18n>
            Non
          </label>
        </div>
      </div>
    </div>
    <ng-container
      *ngIf="metadataFormGroup.controls['hasAlreadyLostLicense'].value"
    >
      <div class="row">
        <div class="col">
          <label i18n>Quand le permis a-t-il est retiré</label>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="lostLicenseDate"
            name="lostLicenseDate"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label i18n>Cause</label>
          <input
            type="text"
            class="form-control"
            formControlName="lostLicenseReason"
          />
        </div>
      </div>
    </ng-container>
    <div class="row">
      <div class="col">
        <label i18n
          >Indépendamment de l'existence d'une casco, les véhicules lui
          appartenant ou conduits par lui-même ont-ils déjà subi des
          dommages ?</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="hasAlreadyTakenDamage"
            id="hasAlreadyTakenDamageTrue"
            [value]="true"
            formControlName="hasAlreadyTakenDamage"
          />
          <label class="form-check-label" for="hasAlreadyTakenDamageTrue" i18n>
            Oui
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="hasAlreadyTakenDamage"
            id="hasAlreadyTakenDamageFalse"
            [value]="false"
            formControlName="hasAlreadyTakenDamage"
          />
          <label class="form-check-label" for="hasAlreadyTakenDamageFalse" i18n>
            Non
          </label>
        </div>
      </div>
    </div>
    <div
      class="row my-2"
      *ngIf="metadataFormGroup.controls['hasAlreadyTakenDamage'].value"
    >
      <div class="col">
        <label i18n>Description des dommages</label>
        <input
          type="text"
          class="form-control"
          formControlName="damageDescription"
        />
      </div>
    </div></div
></ng-container>
